// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-wrapper .notification {
  height: auto !important;
  width: auto !important;
  pointer-events: auto;
}

.notifications-wrapper .notifications-tr,
.notifications-wrapper .notifications-br {
  width: auto !important;
}

/* make position same as tr */

.notifications-wrapper .notifications-br {
  top: 0px !important;
  bottom: auto !important;
  left: auto !important;
  right: 0px !important;
}

.notifications-wrapper .notification > * {
  width: 400px;
}

.notifications-wrapper .notification .notification-details {
  width: 75vw;
  max-height: 300px;
  position: relative;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./../../libs/console/legacy-ce/src/lib/components/Services/Common/Notification/NotificationOverrides.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,6BAA6B;;AAC7B;EACE,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".notifications-wrapper .notification {\n  height: auto !important;\n  width: auto !important;\n  pointer-events: auto;\n}\n\n.notifications-wrapper .notifications-tr,\n.notifications-wrapper .notifications-br {\n  width: auto !important;\n}\n\n/* make position same as tr */\n.notifications-wrapper .notifications-br {\n  top: 0px !important;\n  bottom: auto !important;\n  left: auto !important;\n  right: 0px !important;\n}\n\n.notifications-wrapper .notification > * {\n  width: 400px;\n}\n\n.notifications-wrapper .notification .notification-details {\n  width: 75vw;\n  max-height: 300px;\n  position: relative;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
